const numberFormatter = (v) => {
    return v > 0 ? `+${v}` : String(v);
};
// Возвращает кэф Американского типа
export const americanTypeCf = (cf) => {
    if (cf >= 2)
        return numberFormatter(Math.round((cf * 100) - 100));
    // if(cf >=1 && cf < 2)
    return numberFormatter(Math.round(100 / (1 - cf)));
};
export const hongKongTypeCf = (cf) => {
    if (cf >= 1)
        return (cf - 1);
    return cf;
};
export const indonesianTypeCf = (cf) => {
    if (cf >= 2 || cf === 1)
        return cf - 1;
    // if (cf > 1 && cf < 2)
    return (1 / (1 - cf));
};
export const malaysianTypeCf = (cf) => {
    if (cf >= 1 && cf < 2)
        return (cf - 1);
    // if(cf >= 2)
    return (1 / (1 - cf));
};



// WEBPACK FOOTER //
// ./src/web-frontend-core/helpers/calcCoefType/calcFunctions.js